import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Absence } from 'src/app/_model/Absence';
import { AbsenceService } from 'src/app/_services/absence.service';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_model/user';
import {LookupService} from '../../_services/lookup.service';
import {Lookup} from '../../_model/Lookup';
import {EventService} from '../../_services/event.service';
import {AppConstants} from '../../_utils/constants';
import {FileNameData} from '../../_model/FileNameData';
import {ListDocumentRequest} from '../../_model/request/ListDocumentRequest';
import {StorageService} from '../../_services/storage.service';
import {UtilityService} from '../../_helpers/utility.service';

@Component({
  selector: 'app-absenceapprove',
  templateUrl: './absenceapprove.component.html',
  styleUrls: ['./absenceapprove.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class AbsenceapproveComponent implements OnInit {

  request: WfApproveRequest = new WfApproveRequest();
  currentUser: User;
  approveButtonName = 'Onayla';
  lookupForCurrentAbsence: Lookup;
  lookupList: Lookup[];

  absenceApproveForm: any;
  fileList: FileNameData[] = [];
  fileData: File = null;
  fileUploadProgress: string = null;


  constructor(public dialogRef: MatDialogRef<AbsenceapproveComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence,
              private authService: AuthenticationService,
              private absenceService: AbsenceService,
              private toastr: ToastrService,
              private lookupService: LookupService,
              private storageService: StorageService,
              private utilityService: UtilityService,
              private eventService: EventService) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.lookupForCurrentAbsence = this.lookupService.localListLookups()
        .filter(lookup => {
          if (lookup.id === this.data.absenceTypeId) {
            return lookup;
          }
    })[0];

    const listDocumentRequest: ListDocumentRequest = new ListDocumentRequest('ABSENCE', this.data.id);
    this.storageService.listDocuments(listDocumentRequest).subscribe(listResult => {
      this.fileList = [...this.utilityService.mapPortalDocumentResponseToFileNameData(listResult.responseData.items)];
    });
  }

  closeModal(){
    this.dialogRef.close();
  }

  approveAbsence() {
    // dosya yukleme zorunlulugu sadece ik icin gecerli
    if (this.currentUser.department.id === 3) {
        if (this.lookupForCurrentAbsence.attribute5 != null && this.fileList.length === 0){
            this.toastr.error(this.lookupForCurrentAbsence.attribute5 + ' dosyası yüklenmelidir', 'Hata');
            return;
        }
    }

    if (this.fileList.length > 0) {
        this.request.fileList = this.fileList;
    }

    this.request.employeeId = this.currentUser.employeeId;
    this.request.operationRecordId = this.data.id;
    this.request.operationTableName = 'ABSENCE';
    this.absenceService.approveAbsence(this.request).subscribe(result => {
      this.toastr.success('Onaylama işlemi başarılı', '');
      this.dialogRef.close(true);
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.dialogRef.close(false);
    });
  }

  fileProgress(fileInput: any) {
      this.fileData = fileInput.target.files[0];
  }

  uploadFile() {
      if (this.fileList.length === 2) {
          alert('En fazla iki dosya yüklenebilir');
          return;
      }

      const formData = new FormData();
      formData.append('file', this.fileData);

      const fileSizeInMb = this.fileData.size / 1024 / 1024;
      if (fileSizeInMb >= AppConstants.FILE_UPLOAD_LIMIT) {
          alert('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır');
          this.fileData = null;
          return;
      }

      this.getBase64(this.fileData).then(value => {
          this.fileList.push(new FileNameData(this.fileData.name, value));
      });

      setTimeout(() => this.fileData = null, 500);
  }

  deleteFile(index: number) {
      //this.fileList.splice(index, 1);
      this.fileList[index].willBeDeleted = true;
  }

  getBase64(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
  }
}
